export enum CancelReasonType {
  // 他プロダクトへ乗り換え
  AnotherProduct = 1,
  // 必要な機能がなかった
  LessFeatures = 2,
  // 利用機会が少なかった
  LowUsage = 3,
  // 高い
  Expensive = 4,
  // サポートの問題
  SupportIssues = 5,
  // 使いづらい
  HardToUse = 6,
  // バグが多い
  Bugs = 7,
  // 組織変更
  ChangeOrganization = 8,
  // 一時的な利用
  TemporaryUsage = 9,
  // その他
  Other = 99,
}
